export interface ServerContext {
    apiUrl: string;
    googleMapsApiKey: string;
}

export default (window as any).ClientSettings as ServerContext;
